import { render, staticRenderFns } from "./resolveKitchenItemModalContent.vue?vue&type=template&id=28c4ffb2&scoped=true"
import script from "./resolveKitchenItemModalContent.vue?vue&type=script&lang=js"
export * from "./resolveKitchenItemModalContent.vue?vue&type=script&lang=js"
import style0 from "./resolveKitchenItemModalContent.vue?vue&type=style&index=0&id=28c4ffb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c4ffb2",
  null
  
)

export default component.exports